import { render } from "./wHotClick.vue?vue&type=template&id=dd2cbe54&scoped=true"
import script from "./wHotClick.vue?vue&type=script&lang=js"
export * from "./wHotClick.vue?vue&type=script&lang=js"

import "./wHotClick.vue?vue&type=style&index=0&id=dd2cbe54&scoped=true&lang=scss"

import exportComponent from "/Users/jade/Documents/D1m/website-urlscheme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2cbe54"]])

export default __exports__